const mobileskipStore = ($q, $filter) => {
  // private internal variables
  const _model = {};

  /**
   * Return inmutable with the store's public interface
   */
  return Object.freeze({

  });
};

mobileskipStore.$inject = ['$q', '$filter'];
export {mobileskipStore};



/** WEBPACK FOOTER **
 ** ./src/app/components/mobileskip/mobileskip.store.js
 **/